export const environment = {
  production: false,
  apiBaseUrl: 'https://api.dev.curaconcerto.org/v1/',
  liveInviteTrackingApiUrl: 'https://partnerapicms.dev.curaconcerto.org/',
  appurl: 'https://careapp.dev.curaconcerto.org',
}; 
